import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from 'react-router-dom';
import { MainPage } from './Components/MainPage';
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <>
    <BrowserRouter>
      <Routes>
        <Route exect path='/' element={<MainPage />} />
        <Route path='/about' element={<MainPage />} />
        <Route path='/technologies' element={<MainPage />} />
        <Route path='/projects' element={<MainPage />} />
        <Route path='/contact' element={<MainPage />} />
      </Routes>
    </BrowserRouter>
    <Analytics/>
    </>
  )
}

export default App;
